import YearRoundScenarioView from '@/components/YearRoundScenarioView';
import { getStrategy } from '@/lib/yearRoundStrategies';

export default function StrategyTemOnlySummerPage() {
  const s = getStrategy('tem_only_summer');
  if (!s) return null;
  return <YearRoundScenarioView strategy={s} />;
}
